import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Fuck nonwhites?",
  "description": "",
  "published": "2007-04-20T00:00:00.000Z",
  "redirect_from": ["/blog/fuck-nonwhites/swizec/228"],
  "categories": "food for thought, linkages, video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.illwillpress.com/comm2.html"
      }}>{`Foamy the lord and master`}</a>{` raises a good point once more, as he is so oft to do. The whole rant was about the stupidity of every nonwhite comedian making fun of white people and their own race. But when a white comedian would try making fun of another race there'd be a public uproar and a whole bunch of bad things would happen.`}</p>
    <p>{`So why is this exactly? Why is it that the white race has this stuatus of a master race that isn't allowed to behave like a master race. Sure we conquered the world and are thus a master race. Sure we enslaved and tortured a whole bunch of people. But most of them were white and not some other race. And don't anyone dare think the nonwhites haven't commited attrocities against the white because that would be blatant hypocrisy.`}</p>
    <p>{`The real reason behind all this crap, I think, is simply that the white race is too kind with everyone else. For some reason we have learnt that whenever somebody screams racism we turn around and bend over and allow ourselves to be raped silly.`}</p>
    <p>{`As Foamy said, either everyone makes fun of everyone or nobody makes fun of nobody.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      